import React, {useEffect, useState} from 'react';
import {inject, observer} from 'mobx-react';
import {useNavigate, useParams} from 'react-router-dom';
import {GeneratedVideoChunk} from '../../../data/models/LibraryFile/GeneratedVideoChunk';
import VideoEditorUI from '../view/VideoEditorUI';
import {EditChunkOption} from '../../../data/repositories/LibraryRepository';
import VideoEditorStore from '../store/VideoEditorStore';
import {toastConfig} from '../../../uiToolkit/Toast/toastConfig';
import {toast} from 'react-toastify';

interface Props {
  videoEditorStore?: VideoEditorStore;
}

const EditVideoSourceContainer = inject('videoEditorStore')(
  observer(({videoEditorStore}: Props) => {
    const [chunks, setChunks] = useState<GeneratedVideoChunk[]>([]);
    const {organizationId, mediaFileId} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
      fetchChunks();
      // if (organizationId && mediaFileId) {
      //   videoEditorStore!
      //     .getMediaFile(organizationId, mediaFileId)
      //     .then(setMediaFile);
      // }
    }, [mediaFileId]);

    const fetchChunks = () => {
      if (organizationId && mediaFileId) {
        videoEditorStore!
          .getVideoChunks(organizationId, mediaFileId)
          .then(chunks => {
            setChunks(chunks.sort((x, y) => (x.order > y.order ? 1 : -1)));
          })
          .catch((error: Error) => {
            toast.error(error.message, toastConfig);
          });
      }
    };

    const onBack = () => {
      navigate(`/manage/${organizationId}/library`);
    };

    function onEditChunk(option: EditChunkOption, chunkId: string): void {
      if (videoEditorStore && organizationId && mediaFileId) {
        videoEditorStore.EditChunk(
          organizationId,
          mediaFileId,
          option,
          chunkId,
        );
      }
    }

    const onChunksReorder = (chunks: GeneratedVideoChunk[]) => {
      const newChunks = chunks.map((chunk, index) => ({
        ...chunk,
        order: index,
      }));
      setChunks([...newChunks]);
      if (organizationId && mediaFileId) {
        videoEditorStore!.updateVideoChunksForGeneratedContent(
          organizationId,
          mediaFileId,
          newChunks,
        );
      }
    };

    return !mediaFileId ? null : (
      <>
        <VideoEditorUI
          state={videoEditorStore!.state}
          onBack={onBack}
          chunks={chunks}
          isLoading={videoEditorStore!.isLoading}
          onEditChunk={onEditChunk}
          refreshChunks={fetchChunks}
          onChunksReorder={onChunksReorder}
          editChunkErrorCode={videoEditorStore!.editChunkErrorCode}
          clearErrors={() => (videoEditorStore!.editChunkErrorCode = '')}
        />
        {/* <ConfirmationModal
          title={editVideoSourceText.areYouSure}
          acceptText={appText.accept}
          onAccept={onPublish}
          onCancel={() => setShowSaveConfirmation(false)}
          shown={showSaveConfirmation}
        /> */}
      </>
    );
  }),
);

export default EditVideoSourceContainer;
